module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "about-portrait__card"
  }, [_c('div', {
    staticClass: "portrait"
  }, [_c('el-row', {
    staticClass: "portrait-placeholder-top"
  }, [_c('div', {
    staticClass: "portrait-header"
  }, [_c('div', {
    staticClass: "portrait-header-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/portrait-logo.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portrait-header-label"
  }, [_c('div', {
    staticClass: "portrait-header-id"
  }, [_vm._v("\n            jae hyun choe\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "portrait-header-name"
  }, [_vm._v("\n            jaehyun00917@gmail.com\n          ")])])])]), _vm._v(" "), _c('el-row', {
    nativeOn: {
      "dblclick": function($event) {
        return _vm.toggleLike($event)
      }
    }
  }, [_c('el-col', {
    staticClass: "portrait-placeholder-left",
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "portrait-placeholder-right",
    attrs: {
      "span": 4
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "portrait-placeholder-bottom"
  }, [_c('el-row', [_c('el-button', {
    on: {
      "click": _vm.toggleLike
    }
  }, [(_vm.liked) ? _c('img', {
    attrs: {
      "src": require("../static/instagram-like-filled-icon.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../static/instagram-like-outlined-icon.svg")
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "portrait-comment-button",
    attrs: {
      "title": "jaehyun00917@gmail.com"
    }
  }, [_c('a', {
    attrs: {
      "href": "mailto:jaehyun00917@gmail.com",
      "target": "_top"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../static/instagram-comment-icon.svg")
    }
  })])])], 1), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "portrait-likes"
  }, [_vm._v("\n          " + _vm._s(_vm.likes) + " likes\n        ")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "about-me-container"
  }, [_c('span', {
    staticClass: "about-me-id"
  }, [_vm._v("\n      choe_jaehyun\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "about-me-content"
  }, [_vm._v("\n      " + _vm._s(_vm.aboutMe) + "\n    ")]), _vm._v(" "), _c('br'), _vm._v(".\n    "), _c('br'), _vm._v(".\n    "), _c('br'), _vm._v(".\n    "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "about-me-filter"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('a', {
      key: filter,
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.$emit('update:filterBy', filter)
        }
      }
    }, [_vm._v("\n        #" + _vm._s(filter) + "\n      ")])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6babca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/portrait/portrait.vue
// module id = 284
// module chunks = 0